module.exports = __webpack_public_path__ + "img/bental-kennedy.6e9e2f65.webp";